import { useCallback, useEffect } from "react";
// routes
import { useNavigate, useSearchParams } from "react-router-dom";
import { ROUTES } from "@/core/router/routes";
import { useAuth } from "@/core/context/AuthContext";

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function GuestGuard({ children }: Props) {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get("returnTo") || `/${ROUTES.Dashboard.Root}`;

  const check = useCallback(() => {
    if (isAuthenticated) {
      navigate(returnTo);
    }
  }, [isAuthenticated, returnTo, navigate]);

  useEffect(() => {
    check();
  }, [check]);

  return <>{children}</>;
}
